/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PositionRequestJobAdReviewFinding } from './position-request-job-ad-review-finding';

/**
 * A job ad\'s quality verdict. Shared by the read and save models — what Job Ad Details shows afterwards is exactly what the review endpoint answered and the manager was shown before submitting.
 */
export interface PositionRequestJobAdReview {
  /**
   * `Rejected` exactly when a finding is a blocker; `Unknown` when the agent answered something the             backend could not read. Nothing is gated by it either way.
   */
  decision?: PositionRequestJobAdReviewDecisionEnum;
  /**
   * The plain-language reason, written for the manager about to submit.
   */
  summary?: string | null;
  /**
   * The languages the verdict covered — the ones the job ad was written in when it ran.
   */
  languageCodes?: Array<string> | null;
  /**
   * What to change, most important first. Render them numbered.
   */
  improvements?: Array<string> | null;
  /**
   * The observations behind the improvements, shown expandable.
   */
  findings?: Array<PositionRequestJobAdReviewFinding> | null;
  /**
   * True when the manager submitted although the review rejected the job ad.
   */
  isDismissed?: boolean;
  /**
   * The agent\'s own id for the run. Quote it when reporting a bad verdict.
   */
  runId?: string | null;
  /**
   * When the verdict was stored. Ignored on a save — the server stamps it.
   */
  reviewedAt?: string;
}
export enum PositionRequestJobAdReviewDecisionEnum {
  Unknown = 'Unknown',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
